const BoardingSheetConst = {
    CUCUTA: "CUCUTA",
    TIBU: "TIBU",
}

export default BoardingSheetConst;